import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import Content from "../utilities/content";
import CmsLink from "../utilities/cms-link";

const Popups = () => {
  const [showPopup, setShowPopup] = useState(false);

  //   const location =
  //     typeof window !== "undefined" ? window.location.pathname : "";

  const {
    wp: {
      themeSettings: { themeSettings: data },
    },
  } = useStaticQuery(graphql`
    query Popups {
      wp {
        themeSettings {
          themeSettings {
            showPopup
            popupContent
            popupButton {
              target
              title
              url
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    const currentPage = window.location.pathname;

    // Check if popup has been shown this session
    const popupShownThisSession = sessionStorage.getItem("popupShown");

    // Make sure popup has content, hasn't been shown this sessions, and is on the homepage
    if (data.popupContent && !popupShownThisSession && currentPage === "/") {
      // Show popup and mark as shown for this session
      setShowPopup(true);
      sessionStorage.setItem("popupShown", "true");
    }
  }, []);

  return (
    <>
      {data.showPopup && (
        <div id="website-popups" className={showPopup ? "active" : ""}>
          <div className="popup">
            <div className="popup-content">
              <div className="popup-close" onClick={() => setShowPopup(false)}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
              <Content>{data.popupContent}</Content>
              {data.popupButton && (
                <div className="popup-buttons mt-4">
                  <CmsLink
                    className={`btn btn-primary btn-arrow`}
                    link={data.popupButton}
                    whiteBtn={false}
                    onClick={() => setShowPopup(false)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popups;
